import type { FunctionComponent } from "react";

import { usePostiesQuizContext } from "scmp-app/components/posties/quiz/contexts";
import { PostiesQuizQuestion } from "scmp-app/components/posties/quiz/quiz-question";

import { Container, CurrentQuestionNumber } from "./styles";

type Props = {
  className?: string;
};

export const PostiesQuizQuestions: FunctionComponent<Props> = ({ className }) => {
  const { currentIndex, questions } = usePostiesQuizContext();

  return (
    <Container className={className}>
      <CurrentQuestionNumber>
        {currentIndex + 1} of {questions.length}
      </CurrentQuestionNumber>
      {questions.map((question, index) => (
        <PostiesQuizQuestion index={index} key={index} question={question} />
      ))}
    </Container>
  );
};

PostiesQuizQuestions.displayName = "PostiesQuizQuestions";
